export default function ScienceVisual() {
  const axes = ["Interests", "Personality", "Aptitude", "Values", "Work Style", "Leadership"];
  const sample = [0.82, 0.6, 0.72, 0.55, 0.78, 0.5];
  const cx = 100, cy = 100, r = 78;
  const angleFor = (i) => -Math.PI / 2 + (i * 2 * Math.PI) / axes.length;
  const pointFor = (i, scale) => {
    const a = angleFor(i);
    return [cx + Math.cos(a) * r * scale, cy + Math.sin(a) * r * scale];
  };
  const polygon = (scaleArr) => scaleArr.map((s, i) => pointFor(i, s).join(",")).join(" ");

  return (
    <div className="flex flex-col items-center" data-testid="science-visual-radar">
      <svg viewBox="0 0 200 200" className="w-full max-w-[280px]">
        {[0.25, 0.5, 0.75, 1].map((ring) => (
          <polygon key={ring} points={polygon(axes.map(() => ring))} fill="none" stroke="#E2E8F0" strokeWidth="1" />
        ))}
        {axes.map((_, i) => {
          const [x, y] = pointFor(i, 1);
          return <line key={i} x1={cx} y1={cy} x2={x} y2={y} stroke="#E2E8F0" strokeWidth="1" />;
        })}
        <polygon points={polygon(sample)} fill="url(#radarFill)" stroke="#4338CA" strokeWidth="1.5" />
        {axes.map((_, i) => {
          const [x, y] = pointFor(i, sample[i]);
          return <circle key={i} cx={x} cy={y} r="3" fill="#4338CA" />;
        })}
        <defs>
          <linearGradient id="radarFill" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#4338CA" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#06B6D4" stopOpacity="0.25" />
          </linearGradient>
        </defs>
        {axes.map((label, i) => {
          const [x, y] = pointFor(i, 1.22);
          return (
            <text key={label} x={x} y={y} textAnchor="middle" dominantBaseline="middle" fontSize="9" fill="#64748B">
              {label}
            </text>
          );
        })}
      </svg>
      <p className="text-xs text-slate-400 mt-2 text-center max-w-xs">
        Illustrative example of a multi-dimensional profile — not an actual respondent's data
      </p>
    </div>
  );
}
